import { Layout } from "../components/section";
import { Outlet } from "react-router-dom";

export const Gallery = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};
